import { render, staticRenderFns } from "./RunningOrders.vue?vue&type=template&id=518d81ff&"
import script from "./RunningOrders.vue?vue&type=script&lang=js&"
export * from "./RunningOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports